import { KeyRound } from 'lucide-react';
import { Button } from '@/components/Button';
import { Dialog, DialogButtonGroup, DialogClose } from '@/components/Dialog';
import { Icon } from '@/components/Icon';

type ResetPasswordTarget = {
    name: string;
    email: string;
};

type ResetPasswordDialogProps = {
    target: ResetPasswordTarget | null;
    isSubmitting: boolean;
    onOpenChange: (open: boolean) => void;
    onSubmit: () => Promise<void>;
};

export function ResetPasswordDialog({ target, isSubmitting, onOpenChange, onSubmit }: ResetPasswordDialogProps) {
    return (
        <Dialog title="パスワードをリセットする" open={target !== null} onOpenChange={onOpenChange}>
            <p>
                <strong>{target?.name}</strong> さん（{target?.email}）にパスワード再設定メールを送信します。
                よろしいですか？
            </p>

            <DialogButtonGroup>
                <DialogClose>
                    <Button type="button" variant="secondary">
                        キャンセル
                    </Button>
                </DialogClose>

                <Button type="button" variant="primary" onClick={onSubmit} disabled={isSubmitting}>
                    {isSubmitting ? (
                        '送信中...'
                    ) : (
                        <>
                            <Icon icon={KeyRound} size="sm" />
                            <span>送信する</span>
                        </>
                    )}
                </Button>
            </DialogButtonGroup>
        </Dialog>
    );
}
